export const NoResponse = 0

export const BadRequest = 400
export const Unauthorized = 401
export const Forbidden = 403
export const NotFound = 404
export const MethodNotAllowed = 405
export const Conflict = 409

export const InternalServerError = 500
export const ServiceUnavilable = 503
